<template>
    <div class="w-full h-full flex flex-col">
        <h1 class="text-brand text-lg font-extrabold mb-2 border-gray-200 border-b h-8 overflow-hidden">
            <span class="ml-4 whitespace-nowrap"><i class="far fa-comments mr-4"></i>Notes</span>
        </h1>
        <main ref="notescontainer" class="flex flex-1 flex-col mb-2 pr-4 overflow-y-scroll overflow-x-hidden" @mouseover="(e) => e.target.focus({ focusVisible: false })">
            <notes-v2 :get-url="getUrl()" :post-url="postUrl()"></notes-v2>
        </main>
    </div>
</template>

<script>

import NotesV2 from "../../../NotesV2.vue";

export default {
    components: {
        NotesV2
    },
    props: {
        dashboardData:Object,
        dashboardProps:Object,
    },
    data() {
        return {
            notes: [],
            note: ''
        }
    },
    computed: {
        avatar_url(){
            return appData.user.avatar_url;
        }
    },
    methods: {
        scrollToBottom(){
            let container = this.$refs.notescontainer;

            // We need to delay this a little bit to allow the browser time to render
            // the new data before we actually scroll to the bottom of the container.
            setTimeout(function () {
                container.scrollTop = container.scrollHeight;
            }, 100);
        },
        getUrl() {
            return route('api.v2.organization.package.notes.list',this.dashboardData.legacyPackageItem.reference)
        },
        postUrl() {
            return route('api.v2.organization.package.notes.store',this.dashboardData.legacyPackageItem.reference)
        }
    },
    mounted() {
    }
}

</script>